export const TAG_DISPLAY_NAME = 'MultiSelectColumn';
